import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faBars } from "@fortawesome/free-solid-svg-icons";
import { Typography, Grid, Button } from "@mui/material";

import CommonPagination from "../../../../../reusable-components/CommonPagination/CommonPagination";
import AddNewDocument from "../../../../../containers/AddNewDocument/AddNewDocument";

import { handleDownloadDocsFiles } from "../../../../../services/documents/document-files-api.service";

import { intlFormatDateShort } from "../../../../../utils/time-utils";

import { PAGING_BY_DOCTYPE_PAGE_SIZE } from "../RegistrationsDocumentsIdsPoas";

import { Props } from "./interfaces";
import { Container, DocTypeContainer, Actions, FilesInfo } from "./styles";
import { ALL_LEGISLATIONS_ID } from "../../../../../utils/constants/constants";
import AttachedDocuments from "src/containers/AttachedDocuments/AttachedDocuments";

const LegalEntityRegDoc = ({
  legalEntityRegDocPageByType: { documentType, documents, totalItems, page },
  handleChangePagingByDocType,
  handleNotifyParent,
  currentLegalEntity,
}: Props) => {
  return (
    <Container>
      <DocTypeContainer>
        <Typography>
          {(documentType?.name ?? "") +
            (documentType && documentType?.legislation && documentType?.legislation?.id !== ALL_LEGISLATIONS_ID
              ? " (" + documentType?.legislation?.code + ")"
              : "")}
        </Typography>
        <AddNewDocument
          buttonType="plusButton"
          handleNotifyParent={handleNotifyParent}
          documentFieldsProps={{
            legalEntity: currentLegalEntity,
            category: documentType?.category,
            type: documentType,
          }}
          changeDateOrPeriodOnly
        />
      </DocTypeContainer>
      <Grid>
        {!!documents.length &&
          documents.map((doc) => (
            <AttachedDocuments
              documentIDs={[doc.id]}
              count={doc.filesCount}
              handleNotifyParent={() => handleNotifyParent(doc)}
              buttonSize="2x"
            />
            // <Document
            //   key={id}
            //   onClick={() => handleDownloadDocsFiles([id])}
            // >
            //   {getFontAwesomeIconFromMIME(files[0]?.type)}
            //   <Typography>{intlFormatDate(documentDate ?? files[0]?.createdAt)}</Typography>
            // </Document>
          ))}
      </Grid>
      {totalItems > page.pageSize && documentType && (
        <CommonPagination
          page={page.pageNumber + 1}
          handleChangePage={(page) => handleChangePagingByDocType(documentType.id, page)}
          totalItems={totalItems}
          defaultPageSize={PAGING_BY_DOCTYPE_PAGE_SIZE}
        />
      )}
      {!!documents.length && (
        <Actions>
          <Button onClick={() => handleDownloadDocsFiles(documents.map((d) => d.id))}>
            <FontAwesomeIcon icon={faDownload} />
          </Button>
          <FilesInfo>
            <Button>
              <FontAwesomeIcon icon={faBars} />
            </Button>
            <Grid>
              {documents
                .map((d) => d.files[0])
                .map((f, idx) => (
                  <Typography key={idx}>{`${f?.name} - ${intlFormatDateShort(
                    f?.document?.documentDate ?? f?.createdAt
                  )}`}</Typography>
                ))}
            </Grid>
          </FilesInfo>
        </Actions>
      )}
    </Container>
  );
};

export default LegalEntityRegDoc;
